<template>
  <div >
  <section class="banner-wrapper">
      <div
        class="banner_active"
        :style="{backgroundImage: `url(${require(`@/assets/activity/audi202008.jpg`)})`  }"   />
    </section> 
    <!-- <section class="banner-wrapper">
    <picture >  
  <source  media="(max-width: 500px)" :style="{backgroundImage: `url(${require(`@/assets/img-motor-sketch.jpg`)})`,backgroundSize: `50% auto`  }" >  
  <img  :style="{backgroundImage: `url(${require(`@/assets/activity/12357669503720.jpg`)})` }"  class="banner" >  
</picture>
    </section> -->
 <section class="container">
     <div class="fz-small mb-m">
          <h3>Audi 奧迪車主   預約車險</h3>
          <h3>前進花東專案</h3>
          <br/>
          <p >活動日期:2020/09/1-09/30</p>
          <p >活動辦法: 於磐石保經網路投保平台預約車險成功，有機會獲得花東3天2夜NT$3000招待券</p>
          <br/>
          
          <table  border="1" style="max-width:700px;">
            <tr colspan="2" class="text-center">
              <td>內容</td>
            </tr>
            <tr>
              <td>
                <p>● 住宿兩晚含早餐  ● 當地往返交通自理  ● 當地<span style="color:#fa5555">觀光巴士</span>兩天  ● 當地車導  ● 午晚餐門票自理  ● 行程不進購物店  ● 意外旅平險200萬  ● 醫療20萬</p></td></tr>
          </table>
  <br/>
          <table border="1" style="max-width:700px;">
<thead>
            <tr><td colspan="2" class="text-center">A 花蓮三天二夜山海戀   (花蓮住二晚含早餐)</td></tr>
</thead>
<tbody>
            <tr><td style="min-width:70px">第一天</td><td>自行前往花蓮酒店check in(下午15：30以後)</td></tr>
            <tr><td>第二天<p><span style="color:#fa5555">觀光巴士</span></p></td><td>花蓮境內花東縱谷遊，隨四季不同，安排當季最佳景點，<span style="color:#fa5555">行程約8小時</span>，下午返回花蓮</td></tr>
            <tr><td>第三天<p><span style="color:#fa5555">觀光巴士</span></p></td><td>花蓮境內花東海岸遊，隨四季不同，安排當季最佳景點，<span style="color:#fa5555">行程約8小時</span>，花蓮火車站解散</td></tr>
          </tbody>
          </table>
<br/>
	        <table border="1" style="max-width:700px;">
            <thead>
            <tr><td colspan="2" class="text-center">B 台東三天二夜山海戀   (台東住二晚含早餐)</td></tr>
            </thead>
            <tbody>
            <tr><td style="min-width:70px">第一天</td><td>自行前往台東酒店check in(下午15：30以後)</td></tr>
            <tr><td>第二天<p><span style="color:#fa5555">觀光巴士</span></p></td><td>台東境內花東縱谷遊，隨四季不同，安排當季最佳景點，<span style="color:#fa5555">行程約8小時</span>，下午返回台東</td></tr>
            <tr><td>第三天<p><span style="color:#fa5555">觀光巴士</span></p></td><td>台東境內花東海岸遊，隨四季不同，安排當季最佳景點，<span style="color:#fa5555">行程約8小時</span>，台東火車站解散</td></tr>
          </tbody>
          </table>
           
        </div>
    <div class="text-center mb-m">
           <router-link to="/activity/audicarreserve">
          <Button 
            class="btn-m btn-primary"
            :style="{margin: '0 15px'}"           
            v-text="'預約'"
          />
           </router-link>
          <a  href="https://ec.rockgp.com/insurance/car">
          <Button 
            class="btn-m btn-tertiary"
            :style="{margin: '0 15px'}"           
            v-text="'投保'"

          />
           </a>
      </div>
        <div class="note">
          <div class="note-header">【注意事項】</div>
          <p >A、B都可參加，<span style="color:#fa5555">平日原價3880元/人  抽中只要880元</span></p>
<p>1.旅遊券須於一個月內，向全國旅行社辦理登記，逾期視同放棄，恕不得要求變更、轉換現金或其他等值贈品。</p>
<p>2.登記時須預繳NT$880元，登記後限1年內出發有效(出發前2個月開放預約，若未出發欲辦理退費，須扣NT$100旅行社作業費)。</p>
<p>3.本券僅限本人使用，或轉<span style="color:#fa5555">直系家人</span>及<span style="color:#fa5555">配偶</span>，恕不得轉讓其他親友。</p>
<p>4.如不參加遊覽車行程，可選擇當地<span style="color:#fa5555">【自駕租車方案】</span>平日每車每日額外支付<span style="color:#fa5555">388</span>元。</p>
<p>5.本券為平日出發，假日補差額</p>
<p>6. 假日定義∕<span style="color:#fa5555">(假日補差額)</span></p>
    <p style="text-indent : 2em ;">住宿：週六、連續假日、暑假 (春節另議)</p>
    <p style="text-indent : 2em ;">租車：週五、六、日、連續假日、暑假 (春節另議)</p>
 <p>7.住宿為2人一房，如一人一房須補房差。</p>
 <p>8.登記、訂位及其他未盡事宜，由全國旅行社全權負責，並以全國官網或訂位報名表內容為準。</p>
        </div>     
  </section>  
  </div>
</template>

<script>
//import { mapState } from 'vuex';
import { Button } from "iview";
import axios from 'axios';
import Cookies from 'js-cookie';
//const refid = Cookies.get('refid');

//if (!refid) Cookies.set('refid', "4v6b39qk8b", { expires: 30 });
Cookies.set('refid', "a26gzxnke5", { expires: 30 });
axios.defaults.headers.refid = "a26gzxnke5";
//console.log(axios.defaults.headers.refid);
export default {
  components: {
    axios,
    Button,
    Cookies
    
  }
}

</script>
